import { useContext } from "react";
import { CreditsContext } from "./contexts";

export const useCredits = () => {
  const credits = useContext(CreditsContext);

  if (!credits) {
    throw new Error("Credits context not found");
  }

  return {
    prices: credits.extraCreditPrices,
  };
};
